// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var JsxRuntime = require("react/jsx-runtime");

function PageNotFound(props) {
  return JsxRuntime.jsx("div", {
              children: "Can't seem to find the page you're looking for :/"
            });
}

var make = PageNotFound;

exports.make = make;
/* react/jsx-runtime Not a pure module */
